<script setup lang="ts">
import Markdown from '@satch-ui/components/markdown/Markdown.vue'
import ToastError from '@satch-ui/primitives/toast/ToastError.vue'
import ToastInfo from '@satch-ui/primitives/toast/ToastInfo.vue'
import ToastSuccess from '@satch-ui/primitives/toast/ToastSuccess.vue'
import ToastWarning from '@satch-ui/primitives/toast/ToastWarning.vue'

import { ToastWrapper } from '@fond-of/fondof-ui'
</script>

<template>
  <ToastWrapper>
    <template #warning="{ toggleToast, toast, updateContext }">
      <ToastWarning
        v-bind="toast.options"
        @update:open="toggleToast"
        @update:context="updateContext"
      >
        {{ toast.content }}
      </ToastWarning>
    </template>

    <template #success="{ toggleToast, toast, updateContext }">
      <ToastSuccess
        v-bind="toast.options"
        @update:open="toggleToast"
        @update:context="updateContext"
      >
        {{ toast.content }}
      </ToastSuccess>
    </template>

    <template #error="{ toggleToast, toast, updateContext }">
      <ToastError
        v-bind="toast.options"
        @update:open="toggleToast"
        @update:context="updateContext"
      >
        {{ toast.content }}
      </ToastError>
    </template>

    <template #info="{ toggleToast, toast, updateContext }">
      <ToastInfo
        v-bind="toast.options"
        @update:open="toggleToast"
        @update:context="updateContext"
      >
        <Markdown
          :content="toast.content"
          :variant="null"
        />
      </ToastInfo>
    </template>
  </ToastWrapper>
</template>
